import { AppThunkAction } from '../../index'
import {
	REALTIME_ALERTS_ACTION_TYPES,
	RealtimeAlertsAction,
} from '../../../types/realtimeAlerts'
import { Alert } from '../../../types/alert'
import api from '../../../api'
import { executeResponseError } from '../../../helpers'

export const getRealtimeAlerts =
	(): AppThunkAction<Promise<void>, RealtimeAlertsAction> =>
	async dispatch => {
		try {
			const res = await api.alerts.getAllTypes()

			const allAlerts = res.data?.result || []

			const alerts: Array<Alert> = allAlerts
				.map(alert => {
					if ('eventData' in alert) {
						return {
							...alert,
							...alert.eventData,
						}
					}

					return alert
				})
				.filter(alert => !alert.op?.seenTimestamp)

			dispatch({
				type: REALTIME_ALERTS_ACTION_TYPES.GET,
				payload: alerts,
			})
		} catch (e: any) {
			const error = executeResponseError(e, 'Get alerts error')
			throw new Error(error || '')
		}
	}
